import { makeStyles } from "@mui/styles";
import _cookies from "../../../shared/utils/_cookies";

const contentMixin = (theme) => ({
  transform: "rotate(-45deg)",
  content: `'${_cookies.getItem("auth").user?.nome?.repeat(300)}'`,
  color: "#FF00FF",
  opacity: "0.15",
  lineHeight: "3em",
  letterSacing: "2px",
});

const useWaterMark = makeStyles((theme) => ({
  Watermark: {
    position: "relative",
    "&::after": {
      position: "absolute",
      top: "-75%",
      left: "-75%",
      ...contentMixin(theme),

      pointerEvents: "none",
      display: "block",
      width: "150%",
      height: "150%",
    },
  },
  WatermarkSticky: {
    position: "relative",
    overflow: "hidden",
    "&::after": {
      top: "0",
      left: "0",

      width: "150%",
      height: "150%",

      ...contentMixin(theme),
    },
  },

  WatermarkPdf: {
    position: "relative",
    overflow: "hidden",
  },
  WatermarkScrollthrough: {
    position: "relative",
    overflow: "hidden",
    "&::after": {
      top: "0",
      left: "0",

      width: "100%",
      height: "100%",

      ...contentMixin(theme),
    },
  },

  WatermarkAbsolute: {
    position: "absolute",
    overflow: "hidden",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    "&::after": {
      top: "-25%",
      left: "-25%",

      display: "block",
      width: "150%",
      height: "150%",

      ...contentMixin(theme),
    },
  },
}));

export { useWaterMark };
